import React from 'react'
import PropTypes from 'prop-types'

import { Button, ErrorText, Form, Input, Label } from 'components/Forms'
import HeaderOne from 'components/Headers/HeaderOne'
import PhoneInput from 'sharedComponents/Input/Phone'
import style from './style.module.scss'

VetClinicForm.propTypes = {
  onRemove: PropTypes.func,
  onSubmit: PropTypes.func,
  values: PropTypes.object,
}

function VetClinicForm(props) {
  const { onSubmit, values, onRemove } = props
  const isEditing = !!values

  async function handleSubmit(data) {
    const { name } = data

    if (!name || name === '') {
      throw new Error(`Clinic Name required`)
    }

    await onSubmit(data)
  }

  function handleRemove(event) {
    event.preventDefault()
    onRemove()
  }

  return (
    <div>
      <HeaderOne>{isEditing ? `Edit` : `Add`} Vet Clinic</HeaderOne>
      <Form onSubmit={handleSubmit} values={values}>
        {({ values, onChange, error }) => (
          <React.Fragment>
            <Label htmlFor='vet-clinic-name'>Clinic Name</Label>
            <Input
              name='name'
              value={values.name}
              onChange={onChange}
              id='vet-clinic-name'
            />

            <Label htmlFor='vet-clinic-veterinarianName'>
              Veterinarian Name
            </Label>
            <Input
              name='veterinarianName'
              value={values.veterinarianName}
              onChange={onChange}
              id='vet-clinic-veterinarianName'
            />

            <Label htmlFor='vet-clinic-address'>Clinic Address</Label>
            <Input
              placeholder='Optional'
              name='address'
              value={values.address}
              onChange={onChange}
              id='vet-clinic-address'
            />

            <Label htmlFor='vet-clinic-phoneNumber'>Clinic Phone Number</Label>
            <PhoneInput
              placeholder='Optional'
              name='phoneNumber'
              value={values.phoneNumber}
              onChange={onChange}
              id='vet-clinic-phoneNumber'
            />

            <Label htmlFor='vet-clinic-website'>Clinic Website</Label>
            <Input
              placeholder='Optional'
              name='website'
              value={values.website}
              onChange={onChange}
              id='vet-clinic-website'
            />

            <Label htmlFor='vet-clinic-login'>Login</Label>
            <Input
              placeholder='Optional'
              name='login'
              value={values.login}
              onChange={onChange}
              id='vet-clinic-login'
            />

            <Label htmlFor='vet-clinic-password'>Password</Label>
            <Input
              placeholder='Optional'
              name='password'
              value={values.password}
              onChange={onChange}
              id='vet-clinic-password'
            />

            {error && <ErrorText>{error}</ErrorText>}
            <Button type='submit' small>
              {isEditing ? `Save` : `Add Vet Clinic`}
            </Button>
            {isEditing && (
              <Button
                onClick={handleRemove}
                variant='hollowRed'
                small
                className={style.removeButton}
              >
                Remove
              </Button>
            )}
          </React.Fragment>
        )}
      </Form>
    </div>
  )
}

export default VetClinicForm
